import React from 'react';
import './Footer.css';


import youtubeIcon from '../assets/socialIcons2.png';
import instagramIcon from '../assets/socialIcons1.png';
import tiktokIcon from '../assets/socialIcons3.png';
import xIcon from '../assets/socialIcons4.png';
import snapIcon from '../assets/socialIcons5.png';

import footerRedBg from '../assets/footerBgRed.jpg';

import appStoreBtn from '../assets/footerButtonAppStore.png';
import googlePlayBtn from '../assets/footerButtonGooglePlay.png';

import stillFrontBtn from '../assets/StillfrontLogo.png';
import candyWriterBtn from '../assets/CandywriterLogo.png';
import bitLifeBtn from '../assets/BitlifeLogo.png';

import { trackEvent } from '../utils/Analytics';

function Footer() {

    return (
        <div className="footer-wrapper">
            {/* Yellow top section */}
            <div className="footer-yellow">
                <div className="footer-yellow-content">
                    <div className="social-icons">
                        <a
                            href="https://www.instagram.com/bitlifeapp/"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                                trackEvent('click_instagram', 'social', 'Instagram Icon')
                            }
                        >
                            <img src={instagramIcon} alt="Instagram" />
                        </a>
                        <a
                            href="https://www.youtube.com/@BitLifeApp"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                                trackEvent('click_youtube', 'social', 'YouTube Icon')
                            }
                        >
                            <img src={youtubeIcon} alt="YouTube" />
                        </a>
                        <a
                            href="https://www.tiktok.com/@bitlifeapp"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                                trackEvent('click_tiktok', 'social', 'TikTok Icon')
                            }
                        >
                            <img src={tiktokIcon} alt="TikTok" />
                        </a>
                        <a
                            href="https://x.com/BitLifeApp"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                                trackEvent('click_x', 'social', 'X Icon')
                            }
                        >
                            <img src={xIcon} alt="X" />
                        </a>
                        <a
                            href="https://www.snapchat.com/@bitlifeapp"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                                trackEvent('click_snapchat', 'social', 'SnapChat Icon')
                            }
                        >
                            <img src={snapIcon} alt="SnapChat" />
                        </a>
                    </div>
                </div>
            </div>

            {/* Red middle section */}
            <div className="footer-red" style={{ backgroundImage: `url(${footerRedBg})` }}>
                <div className="footer-store-buttons">
                    <a
                        href="https://bitlife.onelink.me/oNst/v9ynb689"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                            trackEvent('click_ios_store', 'store', 'iOS App Store')
                        }
                    >
                        <img src={appStoreBtn} alt="App Store" className="footer-store-btn" />
                    </a>
                    <a
                        href="https://bitlife.onelink.me/oNst/eooj9dkq"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                            trackEvent('click_android_store', 'store', 'Google Play Store')
                        }
                    >
                        <img src={googlePlayBtn} alt="Google Play" className="footer-store-btn" />
                    </a>
                </div>

                {/* Company Logos image underneath */}
                <div className="footer-company-buttons">
                    <a
                        href="https://www.stillfront.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                            trackEvent('click_stillfront_company', 'company', 'StillFront Website')
                        }
                    >
                        <img src={stillFrontBtn} alt="Stillfront Website" className="footer-store-btn" />
                    </a>
                    <span className="separator">|</span>
                    <a
                        href="https://www.candywriter.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                            trackEvent('click_candywriter_company', 'company', 'Candywriter Website')
                        }
                    >
                        <img src={candyWriterBtn} alt="Candy Writer Website" className="footer-store-btn" />
                    </a>
                    <span className="separator">|</span>
                    <a
                        href="https://bitlife.onelink.me/oNst/v9ynb689"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                            trackEvent('click_bitlife_company', 'company', 'iOS App Store')
                        }
                    >
                        <img src={bitLifeBtn} alt="App Store" className="footer-store-btn" />
                    </a>
                </div>
            </div>

            {/* Black image-based bottom section */}
            <div className="footer-black">
                <span className="separator-black">Copyright 2025 Candywriter</span>
                <span className="separator-black">|</span>
                <span className="separator-black">All Rights Reserved</span>
                <span className="separator-black">|</span>
                <span className="separator-black">
                    <a
                    href="https://candywriter.net/ToS.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="separator-black"
                    style={{ textDecoration: 'none' }}
                    >
                    Terms of Service
                </a></span>
                <span className="separator-black">|</span>
                <span className="separator-black">Powered by Stillfront Germany</span>
            </div>
        </div>
    );
}

export default Footer;
